import { Box, Stack, TertiaryButton, Text } from "flicket-ui";
import omit from "lodash/omit";
import Router from "next/router";
import { INormalisedData } from "~features/nonseated-reservation/nonseated-reservation.types";
import { useOrganization } from "~hooks";
import { MoreDatesButton } from "./MoreDatesButton";

export const Banner = ({
  data,
  isPOSRelease,
}: {
  data: INormalisedData;
  isPOSRelease: boolean;
}) => {
  const { hasFeature } = useOrganization();
  const calendarView = hasFeature("EventCalendarHomepage");

  return (
    <Stack gap={3} flexWrap="wrap">
      <Box flexGrow={1}>
        <Text variant="header.L" mb="1/2">
          {data.name}
        </Text>
        {!isPOSRelease && (
          <>
            <Text variant="regular">{data.displayDate}</Text>
            <Text variant="regular">{data.location}</Text>
          </>
        )}
        {calendarView && (
          <MoreDatesButton>
            <Text variant="regular">More dates</Text>
          </MoreDatesButton>
        )}
      </Box>
      <TertiaryButton
        alignSelf="flex-start"
        href={{
          pathname: `/${data.type === "event" ? "events" : "memberships"}/${
            data.id
          }`,
          query: {
            ...omit(Router.query, ["eventId", "membershipId"]),
          },
        }}
      >
        Event details
      </TertiaryButton>
    </Stack>
  );
};
